import { BatchesService } from '@festina/lifedatareplicator-general-types/lifedatareplicator/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
export type MethodParam = NonNullable<
  Parameters<typeof method>[0]['requestBody']
>

export const useSubmitLifeDataReplicatorBatch = () =>
  useFestinaMutation({
    component: 'lifeDataReplicator',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
